var cov_2lgngzwvv6 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tag/Tag.tsx",
      hash = "aefd27208da2038fd69ba0950e2e62e189f8e8c5",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tag/Tag.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 18
        },
        end: {
          line: 15,
          column: 19
        }
      },
      "1": {
        start: {
          line: 16,
          column: 18
        },
        end: {
          line: 16,
          column: 19
        }
      },
      "2": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 16
        }
      },
      "3": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 39,
          column: 5
        }
      },
      "4": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 42
        }
      },
      "5": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 50
        }
      },
      "6": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 50
        }
      },
      "7": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 50
        }
      },
      "8": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 44
        }
      },
      "9": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 64
        }
      },
      "10": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 46
        }
      },
      "11": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 50
        }
      },
      "12": {
        start: {
          line: 52,
          column: 38
        },
        end: {
          line: 52,
          column: 48
        }
      },
      "13": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      },
      "14": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 40
        }
      },
      "15": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 30
        }
      },
      "16": {
        start: {
          line: 63,
          column: 24
        },
        end: {
          line: 63,
          column: 34
        }
      },
      "17": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 68,
          column: 5
        }
      },
      "18": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 21
        }
      },
      "19": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 12
        }
      },
      "20": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 71,
          column: 5
        }
      },
      "21": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 70,
          column: 27
        }
      },
      "22": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 82,
          column: 5
        }
      },
      "23": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 35
        }
      },
      "24": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 80,
          column: 10
        }
      },
      "25": {
        start: {
          line: 76,
          column: 10
        },
        end: {
          line: 76,
          column: 25
        }
      },
      "26": {
        start: {
          line: 79,
          column: 10
        },
        end: {
          line: 79,
          column: 26
        }
      },
      "27": {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 12
        }
      },
      "28": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 85,
          column: 5
        }
      },
      "29": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 12
        }
      },
      "30": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 19
        }
      },
      "31": {
        start: {
          line: 90,
          column: 28
        },
        end: {
          line: 90,
          column: 38
        }
      },
      "32": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 47
        }
      },
      "33": {
        start: {
          line: 91,
          column: 29
        },
        end: {
          line: 91,
          column: 47
        }
      },
      "34": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 46
        }
      },
      "35": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 28
        }
      },
      "36": {
        start: {
          line: 100,
          column: 36
        },
        end: {
          line: 100,
          column: 46
        }
      },
      "37": {
        start: {
          line: 101,
          column: 28
        },
        end: {
          line: 101,
          column: 38
        }
      },
      "38": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 105,
          column: 5
        }
      },
      "39": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 89
        }
      },
      "40": {
        start: {
          line: 109,
          column: 34
        },
        end: {
          line: 109,
          column: 44
        }
      },
      "41": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 24
        }
      },
      "42": {
        start: {
          line: 110,
          column: 18
        },
        end: {
          line: 110,
          column: 24
        }
      },
      "43": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 29
        }
      },
      "44": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 117,
          column: 5
        }
      },
      "45": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 16
        }
      },
      "46": {
        start: {
          line: 121,
          column: 25
        },
        end: {
          line: 121,
          column: 35
        }
      },
      "47": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 50
        }
      },
      "48": {
        start: {
          line: 122,
          column: 44
        },
        end: {
          line: 122,
          column: 50
        }
      },
      "49": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 19
        }
      },
      "50": {
        start: {
          line: 127,
          column: 24
        },
        end: {
          line: 127,
          column: 34
        }
      },
      "51": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 29
        }
      },
      "52": {
        start: {
          line: 128,
          column: 18
        },
        end: {
          line: 128,
          column: 29
        }
      },
      "53": {
        start: {
          line: 129,
          column: 23
        },
        end: {
          line: 129,
          column: 45
        }
      },
      "54": {
        start: {
          line: 130,
          column: 25
        },
        end: {
          line: 130,
          column: 50
        }
      },
      "55": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 137,
          column: 5
        }
      },
      "56": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 136,
          column: 7
        }
      },
      "57": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 142,
          column: 5
        }
      },
      "58": {
        start: {
          line: 146,
          column: 45
        },
        end: {
          line: 146,
          column: 55
        }
      },
      "59": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 147,
          column: 34
        }
      },
      "60": {
        start: {
          line: 147,
          column: 23
        },
        end: {
          line: 147,
          column: 34
        }
      },
      "61": {
        start: {
          line: 159,
          column: 8
        },
        end: {
          line: 159,
          column: 18
        }
      },
      "62": {
        start: {
          line: 161,
          column: 16
        },
        end: {
          line: 161,
          column: 23
        }
      },
      "63": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 173,
          column: 7
        }
      },
      "64": {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 173,
          column: 7
        }
      },
      "65": {
        start: {
          line: 175,
          column: 27
        },
        end: {
          line: 175,
          column: 45
        }
      },
      "66": {
        start: {
          line: 176,
          column: 22
        },
        end: {
          line: 176,
          column: 32
        }
      },
      "67": {
        start: {
          line: 177,
          column: 23
        },
        end: {
          line: 177,
          column: 80
        }
      },
      "68": {
        start: {
          line: 178,
          column: 28
        },
        end: {
          line: 178,
          column: 46
        }
      },
      "69": {
        start: {
          line: 179,
          column: 18
        },
        end: {
          line: 179,
          column: 63
        }
      },
      "70": {
        start: {
          line: 180,
          column: 19
        },
        end: {
          line: 180,
          column: 30
        }
      },
      "71": {
        start: {
          line: 182,
          column: 4
        },
        end: {
          line: 182,
          column: 50
        }
      },
      "72": {
        start: {
          line: 182,
          column: 19
        },
        end: {
          line: 182,
          column: 50
        }
      },
      "73": {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 190,
          column: 5
        }
      },
      "74": {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 189,
          column: 7
        }
      },
      "75": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 202,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 31
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 32
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        loc: {
          start: {
            line: 51,
            column: 22
          },
          end: {
            line: 56,
            column: 3
          }
        },
        line: 51
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        loc: {
          start: {
            line: 58,
            column: 24
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 58
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        loc: {
          start: {
            line: 62,
            column: 30
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 62
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 75,
            column: 14
          },
          end: {
            line: 75,
            column: 15
          }
        },
        loc: {
          start: {
            line: 75,
            column: 20
          },
          end: {
            line: 77,
            column: 9
          }
        },
        line: 75
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 78,
            column: 15
          },
          end: {
            line: 78,
            column: 16
          }
        },
        loc: {
          start: {
            line: 78,
            column: 21
          },
          end: {
            line: 80,
            column: 9
          }
        },
        line: 78
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        loc: {
          start: {
            line: 89,
            column: 27
          },
          end: {
            line: 93,
            column: 3
          }
        },
        line: 89
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 95,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        },
        loc: {
          start: {
            line: 95,
            column: 29
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 95
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 99,
            column: 2
          },
          end: {
            line: 99,
            column: 3
          }
        },
        loc: {
          start: {
            line: 99,
            column: 23
          },
          end: {
            line: 106,
            column: 3
          }
        },
        line: 99
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 108,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        },
        loc: {
          start: {
            line: 108,
            column: 51
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 108
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 120,
            column: 2
          },
          end: {
            line: 120,
            column: 3
          }
        },
        loc: {
          start: {
            line: 120,
            column: 51
          },
          end: {
            line: 124,
            column: 3
          }
        },
        line: 120
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 126,
            column: 2
          },
          end: {
            line: 126,
            column: 3
          }
        },
        loc: {
          start: {
            line: 126,
            column: 30
          },
          end: {
            line: 143,
            column: 3
          }
        },
        line: 126
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 145,
            column: 2
          },
          end: {
            line: 145,
            column: 3
          }
        },
        loc: {
          start: {
            line: 145,
            column: 11
          },
          end: {
            line: 203,
            column: 3
          }
        },
        line: 145
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }],
        line: 53
      },
      "1": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 19
          }
        }, {
          start: {
            line: 53,
            column: 23
          },
          end: {
            line: 53,
            column: 41
          }
        }, {
          start: {
            line: 53,
            column: 45
          },
          end: {
            line: 53,
            column: 63
          }
        }],
        line: 53
      },
      "2": {
        loc: {
          start: {
            line: 58,
            column: 11
          },
          end: {
            line: 58,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 58,
            column: 21
          },
          end: {
            line: 58,
            column: 22
          }
        }],
        line: 58
      },
      "3": {
        loc: {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }, {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }],
        line: 65
      },
      "4": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        }],
        line: 69
      },
      "5": {
        loc: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }, {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }],
        line: 72
      },
      "6": {
        loc: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }, {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }],
        line: 83
      },
      "7": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 47
          }
        }, {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 47
          }
        }],
        line: 91
      },
      "8": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }],
        line: 103
      },
      "9": {
        loc: {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 103,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 103,
            column: 19
          }
        }, {
          start: {
            line: 103,
            column: 23
          },
          end: {
            line: 103,
            column: 38
          }
        }],
        line: 103
      },
      "10": {
        loc: {
          start: {
            line: 104,
            column: 36
          },
          end: {
            line: 104,
            column: 86
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 104,
            column: 65
          },
          end: {
            line: 104,
            column: 74
          }
        }, {
          start: {
            line: 104,
            column: 77
          },
          end: {
            line: 104,
            column: 86
          }
        }],
        line: 104
      },
      "11": {
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 110,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 110,
            column: 24
          }
        }, {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 110,
            column: 24
          }
        }],
        line: 110
      },
      "12": {
        loc: {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        }, {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        }],
        line: 115
      },
      "13": {
        loc: {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 50
          }
        }, {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 50
          }
        }],
        line: 122
      },
      "14": {
        loc: {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 122,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 122,
            column: 30
          }
        }, {
          start: {
            line: 122,
            column: 34
          },
          end: {
            line: 122,
            column: 42
          }
        }],
        line: 122
      },
      "15": {
        loc: {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 128,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 128,
            column: 29
          }
        }, {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 128,
            column: 29
          }
        }],
        line: 128
      },
      "16": {
        loc: {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        }, {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        }],
        line: 131
      },
      "17": {
        loc: {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 34
          }
        }, {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 34
          }
        }],
        line: 147
      },
      "18": {
        loc: {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 173,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 173,
            column: 7
          }
        }, {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 173,
            column: 7
          }
        }],
        line: 164
      },
      "19": {
        loc: {
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 164,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 164,
            column: 19
          }
        }, {
          start: {
            line: 164,
            column: 23
          },
          end: {
            line: 164,
            column: 49
          }
        }],
        line: 164
      },
      "20": {
        loc: {
          start: {
            line: 177,
            column: 37
          },
          end: {
            line: 177,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 177,
            column: 37
          },
          end: {
            line: 177,
            column: 45
          }
        }, {
          start: {
            line: 177,
            column: 49
          },
          end: {
            line: 177,
            column: 59
          }
        }],
        line: 177
      },
      "21": {
        loc: {
          start: {
            line: 177,
            column: 67
          },
          end: {
            line: 177,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 177,
            column: 67
          },
          end: {
            line: 177,
            column: 70
          }
        }, {
          start: {
            line: 177,
            column: 74
          },
          end: {
            line: 177,
            column: 79
          }
        }],
        line: 177
      },
      "22": {
        loc: {
          start: {
            line: 179,
            column: 18
          },
          end: {
            line: 179,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 179,
            column: 29
          },
          end: {
            line: 179,
            column: 58
          }
        }, {
          start: {
            line: 179,
            column: 61
          },
          end: {
            line: 179,
            column: 63
          }
        }],
        line: 179
      },
      "23": {
        loc: {
          start: {
            line: 180,
            column: 19
          },
          end: {
            line: 180,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 180,
            column: 19
          },
          end: {
            line: 180,
            column: 24
          }
        }, {
          start: {
            line: 180,
            column: 28
          },
          end: {
            line: 180,
            column: 30
          }
        }],
        line: 180
      },
      "24": {
        loc: {
          start: {
            line: 182,
            column: 4
          },
          end: {
            line: 182,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 182,
            column: 4
          },
          end: {
            line: 182,
            column: 50
          }
        }, {
          start: {
            line: 182,
            column: 4
          },
          end: {
            line: 182,
            column: 50
          }
        }],
        line: 182
      },
      "25": {
        loc: {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        }, {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        }],
        line: 183
      },
      "26": {
        loc: {
          start: {
            line: 185,
            column: 15
          },
          end: {
            line: 185,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 185,
            column: 41
          },
          end: {
            line: 185,
            column: 47
          }
        }, {
          start: {
            line: 185,
            column: 50
          },
          end: {
            line: 185,
            column: 56
          }
        }],
        line: 185
      },
      "27": {
        loc: {
          start: {
            line: 193,
            column: 9
          },
          end: {
            line: 199,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 194,
            column: 10
          },
          end: {
            line: 196,
            column: 16
          }
        }, {
          start: {
            line: 198,
            column: 10
          },
          end: {
            line: 198,
            column: 24
          }
        }],
        line: 193
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tag/Tag.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import Input from './Input';
import { defaultProps } from '../utils/defaultProps';
import Spin from '../Spin';
import icons from '../icons';
import { wrapSpan } from '../utils/dom/element';
import { isPromise, isFunc, isString, isEmpty } from '../utils/is';
import { isDark } from '../utils/color';
import { tagClass } from './styles';
import { isRTL } from '../config';
import getDataset from '../utils/dom/getDataset';
var hideInput = (cov_2lgngzwvv6.s[0]++, 0);
var showInput = (cov_2lgngzwvv6.s[1]++, 1);

var Tag =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tag, _PureComponent);

  var _super = _createSuper2(Tag);

  function Tag(props) {
    var _this;

    _classCallCheck(this, Tag);

    cov_2lgngzwvv6.f[0]++;
    cov_2lgngzwvv6.s[2]++;
    _this = _super.call(this, props);
    cov_2lgngzwvv6.s[3]++;
    _this.state = {
      dismiss: 0,
      inputVisible: hideInput,
      // tag input status
      value: null
    };
    cov_2lgngzwvv6.s[4]++;
    _this.dismiss = _this.dismiss.bind(_assertThisInitialized(_this));
    cov_2lgngzwvv6.s[5]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_2lgngzwvv6.s[6]++;
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    cov_2lgngzwvv6.s[7]++;
    _this.renderClose = _this.renderClose.bind(_assertThisInitialized(_this));
    cov_2lgngzwvv6.s[8]++;
    _this.closeTag = _this.closeTag.bind(_assertThisInitialized(_this));
    cov_2lgngzwvv6.s[9]++;
    _this.toggleInputVisible = _this.toggleInputVisible.bind(_assertThisInitialized(_this));
    cov_2lgngzwvv6.s[10]++;
    _this.inputBlur = _this.inputBlur.bind(_assertThisInitialized(_this));
    cov_2lgngzwvv6.s[11]++;
    _this.inputChange = _this.inputChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tag, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2lgngzwvv6.f[1]++;

      var _ref = (cov_2lgngzwvv6.s[12]++, this.props),
          children = _ref.children,
          onCompleted = _ref.onCompleted;

      cov_2lgngzwvv6.s[13]++;

      if ((cov_2lgngzwvv6.b[1][0]++, onCompleted) && (cov_2lgngzwvv6.b[1][1]++, isString(children)) && (cov_2lgngzwvv6.b[1][2]++, !isEmpty(children))) {
        cov_2lgngzwvv6.b[0][0]++;
        cov_2lgngzwvv6.s[14]++;
        this.setState({
          value: children
        });
      } else {
        cov_2lgngzwvv6.b[0][1]++;
      }
    }
  }, {
    key: "closeTag",
    value: function closeTag() {
      var dismiss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2lgngzwvv6.b[2][0]++, 2);
      cov_2lgngzwvv6.f[2]++;
      cov_2lgngzwvv6.s[15]++;
      this.setState({
        dismiss: dismiss
      });
    }
  }, {
    key: "dismiss",
    value: function dismiss(e) {
      var _this2 = this;

      cov_2lgngzwvv6.f[3]++;

      var _ref2 = (cov_2lgngzwvv6.s[16]++, this.props),
          onClose = _ref2.onClose;

      var callback;
      cov_2lgngzwvv6.s[17]++;

      if (onClose === true) {
        cov_2lgngzwvv6.b[3][0]++;
        cov_2lgngzwvv6.s[18]++;
        this.closeTag();
        cov_2lgngzwvv6.s[19]++;
        return;
      } else {
        cov_2lgngzwvv6.b[3][1]++;
      }

      cov_2lgngzwvv6.s[20]++;

      if (typeof onClose === 'function') {
        cov_2lgngzwvv6.b[4][0]++;
        cov_2lgngzwvv6.s[21]++;
        callback = onClose(e);
      } else {
        cov_2lgngzwvv6.b[4][1]++;
      }

      cov_2lgngzwvv6.s[22]++;

      if (isPromise(callback)) {
        cov_2lgngzwvv6.b[5][0]++;
        cov_2lgngzwvv6.s[23]++;
        this.setState({
          dismiss: 1
        });
        cov_2lgngzwvv6.s[24]++;
        callback.then(function () {
          cov_2lgngzwvv6.f[4]++;
          cov_2lgngzwvv6.s[25]++;

          _this2.closeTag();
        })["catch"](function () {
          cov_2lgngzwvv6.f[5]++;
          cov_2lgngzwvv6.s[26]++;

          _this2.closeTag(0);
        });
        cov_2lgngzwvv6.s[27]++;
        return;
      } else {
        cov_2lgngzwvv6.b[5][1]++;
      }

      cov_2lgngzwvv6.s[28]++;

      if (e.defaultPrevented) {
        cov_2lgngzwvv6.b[6][0]++;
        cov_2lgngzwvv6.s[29]++;
        return;
      } else {
        cov_2lgngzwvv6.b[6][1]++;
      }

      cov_2lgngzwvv6.s[30]++;
      this.closeTag();
    }
  }, {
    key: "inputBlur",
    value: function inputBlur(value) {
      cov_2lgngzwvv6.f[6]++;

      var _ref3 = (cov_2lgngzwvv6.s[31]++, this.props),
          onCompleted = _ref3.onCompleted;

      cov_2lgngzwvv6.s[32]++;

      if (isFunc(onCompleted)) {
        cov_2lgngzwvv6.b[7][0]++;
        cov_2lgngzwvv6.s[33]++;
        onCompleted(value);
      } else {
        cov_2lgngzwvv6.b[7][1]++;
      }

      cov_2lgngzwvv6.s[34]++;
      this.setState({
        inputVisible: hideInput
      });
    }
  }, {
    key: "inputChange",
    value: function inputChange(value) {
      cov_2lgngzwvv6.f[7]++;
      cov_2lgngzwvv6.s[35]++;
      this.setState({
        value: value
      });
    }
  }, {
    key: "toggleInputVisible",
    value: function toggleInputVisible() {
      cov_2lgngzwvv6.f[8]++;

      var _ref4 = (cov_2lgngzwvv6.s[36]++, this.state),
          inputVisible = _ref4.inputVisible,
          value = _ref4.value;

      var _ref5 = (cov_2lgngzwvv6.s[37]++, this.props),
          onCompleted = _ref5.onCompleted; // if onCompleted is not null


      cov_2lgngzwvv6.s[38]++;

      if ((cov_2lgngzwvv6.b[9][0]++, onCompleted) && (cov_2lgngzwvv6.b[9][1]++, !isEmpty(value))) {
        cov_2lgngzwvv6.b[8][0]++;
        cov_2lgngzwvv6.s[39]++;
        this.setState({
          inputVisible: inputVisible === hideInput ? (cov_2lgngzwvv6.b[10][0]++, showInput) : (cov_2lgngzwvv6.b[10][1]++, hideInput)
        });
      } else {
        cov_2lgngzwvv6.b[8][1]++;
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      cov_2lgngzwvv6.f[9]++;

      var _ref6 = (cov_2lgngzwvv6.s[40]++, this.props),
          onClick = _ref6.onClick,
          disabled = _ref6.disabled;

      cov_2lgngzwvv6.s[41]++;

      if (disabled) {
        cov_2lgngzwvv6.b[11][0]++;
        cov_2lgngzwvv6.s[42]++;
        return;
      } else {
        cov_2lgngzwvv6.b[11][1]++;
      } // toggle input visible


      cov_2lgngzwvv6.s[43]++;
      this.toggleInputVisible();
      cov_2lgngzwvv6.s[44]++;

      if (typeof onClick === 'function') {
        cov_2lgngzwvv6.b[12][0]++;
        cov_2lgngzwvv6.s[45]++;
        onClick(e);
      } else {
        cov_2lgngzwvv6.b[12][1]++;
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose(e) {
      cov_2lgngzwvv6.f[10]++;

      var _ref7 = (cov_2lgngzwvv6.s[46]++, this.props),
          disabled = _ref7.disabled;

      cov_2lgngzwvv6.s[47]++;

      if ((cov_2lgngzwvv6.b[14][0]++, this.state.dismiss > 0) || (cov_2lgngzwvv6.b[14][1]++, disabled)) {
        cov_2lgngzwvv6.b[13][0]++;
        cov_2lgngzwvv6.s[48]++;
        return;
      } else {
        cov_2lgngzwvv6.b[13][1]++;
      }

      cov_2lgngzwvv6.s[49]++;
      this.dismiss(e);
    }
  }, {
    key: "renderClose",
    value: function renderClose(dismiss) {
      cov_2lgngzwvv6.f[11]++;

      var _ref8 = (cov_2lgngzwvv6.s[50]++, this.props),
          onClose = _ref8.onClose;

      cov_2lgngzwvv6.s[51]++;

      if (!onClose) {
        cov_2lgngzwvv6.b[15][0]++;
        cov_2lgngzwvv6.s[52]++;
        return null;
      } else {
        cov_2lgngzwvv6.b[15][1]++;
      }

      var closeClass = (cov_2lgngzwvv6.s[53]++, tagClass('close-icon'));
      var loadingClass = (cov_2lgngzwvv6.s[54]++, tagClass('close-loading'));
      cov_2lgngzwvv6.s[55]++;

      if (dismiss === 0) {
        cov_2lgngzwvv6.b[16][0]++;
        cov_2lgngzwvv6.s[56]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: closeClass,
            onClick: this.handleClose,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 133,
              columnNumber: 9
            }
          }, icons.Close)
        );
      } else {
        cov_2lgngzwvv6.b[16][1]++;
      }

      cov_2lgngzwvv6.s[57]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: loadingClass,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 139,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Spin, {
          name: "ring",
          size: 10,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 140,
            columnNumber: 9
          }
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_2lgngzwvv6.f[12]++;

      var _ref9 = (cov_2lgngzwvv6.s[58]++, this.state),
          dismiss = _ref9.dismiss,
          inputVisible = _ref9.inputVisible,
          value = _ref9.value;

      cov_2lgngzwvv6.s[59]++;

      if (dismiss === 2) {
        cov_2lgngzwvv6.b[17][0]++;
        cov_2lgngzwvv6.s[60]++;
        return null;
      } else {
        cov_2lgngzwvv6.b[17][1]++;
      }

      var _ref10 = (cov_2lgngzwvv6.s[61]++, this.props),
          children = _ref10.children,
          className = _ref10.className,
          type = _ref10.type,
          backgroundColor = _ref10.backgroundColor,
          onClose = _ref10.onClose,
          disabled = _ref10.disabled,
          onCompleted = _ref10.onCompleted,
          onEnterPress = _ref10.onEnterPress,
          onKeyUp = _ref10.onKeyUp;

      var rtl = (cov_2lgngzwvv6.s[62]++, isRTL()); // if editable and input visible

      cov_2lgngzwvv6.s[63]++;

      if ((cov_2lgngzwvv6.b[19][0]++, onCompleted) && (cov_2lgngzwvv6.b[19][1]++, inputVisible === showInput)) {
        cov_2lgngzwvv6.b[18][0]++;
        cov_2lgngzwvv6.s[64]++;
        return (
          /*#__PURE__*/
          React.createElement(Input, {
            value: value,
            onBlur: this.inputBlur,
            onChange: this.inputChange,
            onEnterPress: onEnterPress,
            onKeyUp: onKeyUp,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 166,
              columnNumber: 9
            }
          })
        );
      } else {
        cov_2lgngzwvv6.b[18][1]++;
      }

      var childrenParsed = (cov_2lgngzwvv6.s[65]++, wrapSpan(children));

      var _ref11 = (cov_2lgngzwvv6.s[66]++, this.props),
          style = _ref11.style;

      var tagClassName = (cov_2lgngzwvv6.s[67]++, tagClass('_', (cov_2lgngzwvv6.b[20][0]++, disabled) && (cov_2lgngzwvv6.b[20][1]++, 'disabled'), type, (cov_2lgngzwvv6.b[21][0]++, rtl) && (cov_2lgngzwvv6.b[21][1]++, 'rtl')));
      var inlineClassName = (cov_2lgngzwvv6.s[68]++, tagClass('inline'));
      var click = (cov_2lgngzwvv6.s[69]++, !onClose ? (cov_2lgngzwvv6.b[22][0]++, {
        onClick: this.handleClick
      }) : (cov_2lgngzwvv6.b[22][1]++, {}));
      var tagStyle = (cov_2lgngzwvv6.s[70]++, (cov_2lgngzwvv6.b[23][0]++, style) || (cov_2lgngzwvv6.b[23][1]++, {}));
      cov_2lgngzwvv6.s[71]++;

      if (className) {
        cov_2lgngzwvv6.b[24][0]++;
        cov_2lgngzwvv6.s[72]++;
        tagClassName += " ".concat(className);
      } else {
        cov_2lgngzwvv6.b[24][1]++;
      }

      cov_2lgngzwvv6.s[73]++;

      if (backgroundColor) {
        cov_2lgngzwvv6.b[25][0]++;
        cov_2lgngzwvv6.s[74]++;
        tagStyle = _objectSpread2({
          color: isDark(backgroundColor) ? (cov_2lgngzwvv6.b[26][0]++, '#fff') : (cov_2lgngzwvv6.b[26][1]++, '#000'),
          backgroundColor: backgroundColor,
          borderColor: 'transparent'
        }, style);
      } else {
        cov_2lgngzwvv6.b[25][1]++;
      }

      cov_2lgngzwvv6.s[75]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: tagClassName,
          style: tagStyle
        }, click, getDataset(this.props), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 192,
            columnNumber: 7
          }
        }), onClose ? (cov_2lgngzwvv6.b[27][0]++,
        /*#__PURE__*/
        React.createElement("div", {
          onClick: this.handleClick,
          className: inlineClassName,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 194,
            columnNumber: 11
          }
        }, childrenParsed)) : (cov_2lgngzwvv6.b[27][1]++, childrenParsed), this.renderClose(dismiss))
      );
    }
  }]);

  return Tag;
}(PureComponent);

Tag.defaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  type: 'default'
});
export default Tag;